import React, { useEffect, useState } from 'react';
import { Lock } from 'lucide-react';
import { api } from '../context/AuthContext';

const formatN = (n) => new Intl.NumberFormat('fr-FR').format(n || 0);

export function PrivateDonationsCard({ cagnotteId, accent, refreshKey }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/cagnottes/${cagnotteId}/dons-prives`)
      .then((r) => { if (alive) setData(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, [cagnotteId, refreshKey]);

  if (!data?.isOrganizer || !(data.items || []).length) return null;

  return (
    <div className="rounded-3xl bg-white border border-black/5 p-6 sm:p-7" data-testid="private-donations-card">
      <div className="flex items-baseline justify-between">
        <h2 className="text-[18px] font-semibold text-[#1a1d1a] flex items-center gap-2">
          <Lock className="w-4 h-4" style={{ color: accent }} /> Dons privés reçus
        </h2>
        <span className="text-[12.5px] text-neutral-500">{data.items.length}</span>
      </div>
      <p className="mt-2 text-[11.5px] text-neutral-500">
        Visibles uniquement par vous (organisateur) et l'administration. Jamais affichés publiquement.
      </p>
      <div className="mt-3 divide-y divide-black/5">
        {data.items.map((d) => (
          <div key={d.id} className="py-3 flex items-start justify-between gap-3" data-testid="private-donation-row">
            <div className="min-w-0">
              <div className="text-[13.5px] font-medium text-[#1a1d1a] flex items-center gap-1.5">
                <Lock className="w-3 h-3 text-neutral-400 shrink-0" /> {d.donorName}
              </div>
              {d.message && <div className="mt-0.5 text-[12.5px] text-neutral-600 truncate">{d.message}</div>}
              <div className="mt-0.5 text-[11px] text-neutral-400">{d.createdAt ? new Date(d.createdAt).toLocaleDateString('fr-FR') : ''}</div>
            </div>
            <div className="text-[14px] font-semibold shrink-0" style={{ color: accent }}>{formatN(d.amount)} FCFA</div>
          </div>
        ))}
      </div>
    </div>
  );
}
